module.exports = __webpack_public_path__ + "img/eit3-flow2-en.82de8537.png";